import { UserOutlined } from "@ant-design/icons";
import { ProfileView } from "../components/View/ProfileView";
import { UserRole } from "@root/api.types";
export const PROFILE_VIEW = {
    path: "/admin/profile",
    component: ProfileView,
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    menu: {
        key: "USERS_LIST",
        label: "management.users.menu.title",
        icon: UserOutlined,
    },
};
